import { Link } from 'react-router-dom';
import { MapPin, Clock, Globe, Linkedin, Instagram, Mail } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="text-2xl font-bold text-gray-900 mb-4">
              Solo<span className="text-blue-600">Scale</span>
            </div>
            <p className="text-gray-600 mb-4 max-w-md">
              {mockData.brand.description}
            </p>
            <div className="flex items-start space-x-2 text-sm text-gray-600 mb-3">
              <MapPin className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <span>{mockData.contact.address}</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600 mb-3">
              <Clock className="h-5 w-5 text-blue-600 flex-shrink-0" />
              <span>{mockData.contact.hours}</span>
            </div>
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <Globe className="h-5 w-5 text-blue-600 flex-shrink-0" />
              <span>{mockData.contact.serviceArea}</span>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/platforms" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  Platforms
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-600 hover:text-blue-600 transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Social Links */}
          <div>
            <h3 className="font-semibold text-gray-900 mb-4">Connect With Us</h3>
            <div className="space-y-3">
              <a 
                href="#" 
                onClick={(e) => e.preventDefault()}
                className="flex items-center space-x-2 text-gray-400 cursor-not-allowed text-sm"
                title="Company LinkedIn page - Coming soon"
              >
                <Linkedin className="h-5 w-5" />
                <span>LinkedIn (Coming Soon)</span>
              </a>
              <a 
                href="#" 
                onClick={(e) => e.preventDefault()}
                className="flex items-center space-x-2 text-gray-400 cursor-not-allowed text-sm"
                title="Business Instagram account - Coming soon"
              >
                <Instagram className="h-5 w-5" />
                <span>Instagram (Coming Soon)</span>
              </a>
              <a 
                href="#" 
                onClick={(e) => e.preventDefault()}
                className="flex items-center space-x-2 text-gray-400 cursor-not-allowed text-sm"
                title="WhatsApp Business - Coming soon"
              >
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span>WhatsApp (Coming Soon)</span>
              </a>
              <a 
                href="mailto:info@soloscale.in"
                className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors text-sm"
              >
                <Mail className="h-5 w-5" />
                <span>info@soloscale.in</span>
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-600">
              © {currentYear} SoloScale. All rights reserved.
            </p>
            <p className="text-sm text-gray-600 mt-2 md:mt-0">
              Delivery Mode: {mockData.contact.deliveryMode}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
